export const PANEL_Z_INDEX = 1065;
export const PANEL_TRANSITION_MS = 180;
export const ONBOARDING_AGENT_VIEWPORT_MARGIN = 16;
export const ONBOARDING_AGENT_TRIGGER_SIZE = 54;
export const ONBOARDING_AGENT_PANEL_WIDTH = 360;
export const ONBOARDING_AGENT_PANEL_HEIGHT = 588;
export const ONBOARDING_AGENT_PANEL_EXPANDED_HEIGHT_OFFSET = 48;
export const ONBOARDING_AGENT_PANEL_RESIZE_TRANSITION_MS = 220;
export const ONBOARDING_AGENT_DEFAULT_SCREEN_OFFSET = 24;

export const ONBOARDING_AGENT_NUDGE_DELAY_MS = 60 * 1000;
export const ONBOARDING_AGENT_NUDGE_COOLDOWN_MS = 24 * 60 * 60 * 1000;
